// 商铺首页
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '../../components/common';

import Header from '../../components/Header/index';
import TopNav from '../../components/TopNav/index';

import config from '../../utils/config';
import request from '../../utils/request';
import { pushPath } from '../../utils/utils';
import '../../components/shop/common';
import * as utils from '../../utils/utils';
import Toast from '../../components/popup/toast';


export default class Store extends React.Component < {}, any > {
    private toastTimer: any;
    private ref = {
        elCode1: null,
        elCode2: null,
        elCode3: null,
        elCode4: null
    }
    constructor(props: any) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
            bannerList: [], // 广告数据
            goodList: {
                tab: [],
                goods: []
            }, // 商品数据
            id: '', // 企业id
            shopId: '', // 店铺id
            shopDomain: '', // 店铺域名
            shopInfo: {}, // 店铺信息
            modelsId: '', // 模板id
            styleConfig: {},
            mofanList: '', // 魔方数据
            isMiniBaiduProgram: (window as any).isMiniBaiduProgram, // 是否在百度小程序中
            toastText: '', // 提示文本
            toastVisible: false, // 提示框可视化
            // 扫码活动关注
            offline: utils.GetQueryString('offline') || '', // 是否线下扫码
            collectionNum: 0, // 关注数量
            collectVisible: true, // 关注提示显示
            collectCode: [], // 关注码
            collectCodeVisible: false, // 关注码显示隐藏
            isCollection: false, // 是否关注了

            activityId: utils.GetQueryString('exActivityId') || '',
            exhibitionId: utils.GetQueryString('exhibitionId') || '',
            exhibitionMerchantId: utils.GetQueryString('exhibitionMerchantId') || '',
            fromExhibitionActivity: utils.GetQueryString('exhibition') === '1', // 展会活动跳转过来
            activityType: utils.GetQueryString('exActivityType') || '',
            exhibitionTime: 15, // 展会活动15秒倒计时
        };
    }
    public componentDidMount() {

        this._getId();
        this._getBanner();

        if (this.state.offline === '1') {
            this.getCollectionNum();
            this.getActivityCollection();
        }

        // 慧正店铺首页添加客服
        if (utils.checkShopId() === 'hzeyun') {
            this.addService();
        }
    }

    public render() {
        const that = this;
        const { styleConfig } = this.state;

        return (
            <div>
                <Header isCollect={this.state.offline === '1' ? this.state.isCollection : undefined} collectCallBack={(status: any) => this.collectCallBack()}>
                </Header>
                {/* banner 开始 */}
                {
                    this.state.bannerList.length > 0 && this.state.bannerList.map((bv: any, bk: number) => {
                        return (
                          bv ?
                          (
                            bv.type < 3 ?
                              <div className="focus" key={`swiperItem${bk}`}>
                                  <div className="banner">
                                      <div className={`swiper-container goods-banner swiper${bk}`}>
                                          <div className="swiper-wrapper">
                                              {
                                                  bv.banner_info.map(function(v:any, k:number){
                                                      return (
                                                          <div className="swiper-slide" key={`banner-info-item-${k}`}>
                                                              <a href={v.banner_url}><img src={v.banner_img} alt=""/></a>
                                                          </div>
                                                      )
                                                  })
                                              }

                                          </div>
                                          <div className={`swiper-pagination swiper-pagination${bk}`}>
                                            {
                                                (bv.banner_info && bv.banner_info.length > 1) ? bv.banner_info.map(function(v:any, k:number){
                                                    return (
                                                        <span className={`swiper-pagination-bullet ${k === 0 ? '' : 'swiper-pagination-bullet-active'}`} key={`swiperPagination${k}`}></span>
                                                    )
                                                }) : null
                                            }
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              : this._renderAd(bk, bv)
                          ) : null
                        )
                    }) 
                    
                }

                {
                    (this.state.bannerList.length === 0 && styleConfig.wap_top_banner) && 
                        <div className="focus" >
                            <div className="banner" style={{ display: styleConfig.wap_top_banner ? 'block' : 'none' }}>
                                <img src={styleConfig.wap_top_banner} alt=""/>
                            </div>
                        </div>
                    
                }

                <div className="all column-box">
                    <div className="newtitle">
                      <h4>商品推荐</h4>
                      <span><a href="javascript: void(0);" onClick={() => pushPath('/offerlist', '')}>查看全部 &gt;</a></span>
                    </div>
                    <div>
                      <div className="list">
                         {
                            this.state.goodList.tab.map(function(v:any) {
                                return that.renderGoodsItem(v)
                            })
                        }
                        {
                            this.state.goodList.goods.map(function(v:any, k:number) {
                                return that.renderGoodsItem(v)
                            })
                        }
                    </div>
                  </div>
                </div>
                {
                    this.state.offline === '1' ?
                    <div>
                        <div className="hdjz" onClick={() => this.goToActivity()}>
                          <span>活动进展</span>
                          <i>{this.state.collectionNum}/10</i>
                        </div>
                        {
                            this.state.collectVisible ?
                            <div className="hdjzxq">
                              <p>{
                                  Number(this.state.collectionNum) >= 10 ? '已关注'+this.state.collectionNum+'个店铺，快去领取奖品吧' : '再关注' + (10 - this.state.collectionNum) +'个店铺，即可领取奖品'}</p><img src={require('../../assets/images/gb.png')} className="gb" onClick={() => this.setCollection(false)}/>
                            </div> : null
                        }
                    </div> : null
                }
               
                {
                    this.state.offline === '1' && this.state.collectCodeVisible ? 
                    <div>
                        <div id="fullScreen"></div>
                        <div className="cjCon">
                            <span className="close" onClick={ () => this.setCollectCodeVisible(false) }></span>
                            <div className="tctop"> <h3>请输入确认码</h3></div>
                            <div className="ipt">
                                <input type="tel" maxLength={1} ref={ (ref: any) => this.ref.elCode1 = ref } onKeyUp={ () => this.codeKeyUpAction(1) } onChange={ () => this.codeInputAction(0) }/>
                                <input type="tel" maxLength={1} ref={ (ref: any) => this.ref.elCode2 = ref } onKeyUp={ () => this.codeKeyUpAction(2) } onChange={ () => this.codeInputAction(1) }/>
                                <input type="tel" maxLength={1} ref={ (ref: any) => this.ref.elCode3 = ref } onKeyUp={ () => this.codeKeyUpAction(3) } onChange={ () => this.codeInputAction(2) }/>
                                <input type="tel" maxLength={1} ref={ (ref: any) => this.ref.elCode4 = ref } onKeyUp={ () => this.codeKeyUpAction(4) } onChange={ () => this.codeInputAction(3) }/>
                            </div>
                            <button className="btn" onClick={ () => this.codeSubmit() }>确认</button>
                        </div>
                    </div> : null
                }
                
                {
                    this.state.fromExhibitionActivity ?
                    <div className={`${this.state.exhibitionTime > 0 ? 'djs1' : 'djs2'}`} onClick={() => this.cashPrice()}>
                        <i>{this.state.exhibitionTime > 0 ? (this.state.exhibitionTime + 's') : '已完成' }</i>
                    </div> : null
                }
                <TopNav styleConfig={this.state.styleConfig} />
                <Toast text={this.state.toastText} visible={this.state.toastVisible} />
            </div>
        )
    }

    // 渲染魔方
    private _renderModel(data: any) {
        let template = '';

        switch (`${data.modelId}`) {
            case '0':
                template = '<div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px" data-index="1"><a href="' + (data.img[0] ? data.img[0].link : '') + '"><img src="' + (data.img[0] ? data.img[0].url : '') + '"  alt="" /></a></div>';
                break;
            case '1':
                template = '<div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px" data-index="1"><a href="' + (data.img[0] ? data.img[0].link : '') + '"><img src="' + (data.img[0] ? data.img[0].url : '') + '"  alt="" /></a></div><div class="layout-item" data-index="2"><a href="' + (data.img[1] ? data.img[1].link : '') + '"><img src="' + (data.img[1] ? data.img[1].url : '') + '"  alt="" /></a></div>';
                break;
            case '2':
                template = '<div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px " data-index="1"><a href="' + (data.img[0] ? data.img[0].link : '') + '"><img src="' + (data.img[0] ? data.img[0].url : '') + '"  alt="" /></a></div><div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px " data-index="2"><a href="' + (data.img[1] ? data.img[1].link : '') + '"><img src="' + (data.img[1] ? data.img[1].url : '') + '"  alt="" /></a></div><div class="layout-item" data-index="3"><a href="' + (data.img[2] ? data.img[2].link : '') + '"><img src="' + (data.img[2] ? data.img[2].url : '') + '"  alt="" /></a></div>';
                break;
            case '3':
                template = '<div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px " data-index="1"><a href="' + (data.img[0] ? data.img[0].link : '') + '"><img src="' + (data.img[0] ? data.img[0].url : '') + '"  alt="" /></a></div><div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px " data-index="2"><a href="' + (data.img[1] ? data.img[1].link : '') + '"><img src="' + (data.img[1] ? data.img[1].url : '') + '"  alt="" /></a></div><div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px " data-index="3"><a href="' + (data.img[2] ? data.img[2].link : '') + '"><img src="' + (data.img[2] ? data.img[2].url : '') + '"  alt="" /></a></div><div class="layout-item" data-index="4"><a href="' + (data.img[3] ? data.img[3].link : '') + '"><img src="' + (data.img[3] ? data.img[3].url : '') + '"  alt="" /></a></div>';
                break;
            case '4':
                template = '<div class="layout-box" style="min-width: 100%; height: 50%; display: flex; padding-bottom: ' + parseInt(data.range, 10) / 4 + 'px "> <div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px " data-index="1"><a href="' + (data.img[0] ? data.img[0].link : '') + '"><img src="' + (data.img[0] ? data.img[0].url : '') + '"  alt="" /></a></div> <div class="layout-item"  data-index="2"><a href="' + (data.img[1] ? data.img[1].link : '') + '"><img src="' + (data.img[1] ? data.img[1].url : '') + '"  alt="" /></a></div> </div> <div class="layout-box" style="min-width: 100%; height: 50%; display: flex; padding-top: ' + parseInt(data.range, 10) / 4 + 'px"> <div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) + 'px " data-index="3"><a href="' + (data.img[2] ? data.img[2].link : '') + '"><img src="' + (data.img[2] ? data.img[2].url : '') + '"  alt="" /></a></div> <div class="layout-item"  data-index="4"><a href="' + (data.img[3] ? data.img[3].link : '') + '"><img src="' + (data.img[3] ? data.img[3].url : '') + '"  alt="" /></a></div> </div>';
                break;
            case '5':
                template = '<div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px " data-index="1"><a href="' + (data.img[0] ? data.img[0].link : '') + '"><img src="' + (data.img[0] ? data.img[0].url : '') + '"  alt="" /></a></div> <div class="layout-box " style="display: flex; flex: 1; flex-direction: column;"> <div class="layout-item" style="min-width: 100%; height: 50%; display: flex; margin-bottom: ' + parseInt(data.range, 10) / 2 + 'px " data-index="2"><a href="' + (data.img[1] ? data.img[1].link : '') + '"><img src="' + (data.img[1] ? data.img[1].url : '') + '"  alt="" /></a></div> <div class="layout-item" style="min-width: 100%; height: 50%; display: flex; " data-index="3"><a href="' + (data.img[2] ? data.img[2].link : '') + '"><img src="' + (data.img[2] ? data.img[2].url : '') + '"  alt="" /></a></div> </div>';
                break;
            case '6':
                template = '<div class="layout-box" style="width: 100%; height: 100%;"><div class="layout-item" style="height: 50%; display: flex; padding-bottom: ' + parseInt(data.range, 10) / 2 + 'px " data-index="1"><a href="' + (data.img[0] ? data.img[0].link : '') + '"><img src="' + (data.img[0] ? data.img[0].url : '') + '"  alt="" /></a></div><div class="layout-box" data-index="2" style="height: 50%; display: flex; flex: 1;"> <div class="layout-item" data-index="2" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px  "><a href="' + (data.img[1] ? data.img[1].link : '') + '"><img src="' + (data.img[1] ? data.img[1].url : '') + '"  alt="" /></a></div><div class="layout-item" data-index="3" style=""><a href="' + (data.img[2] ? data.img[2].link : '') + '"><img src="' + (data.img[2] ? data.img[2].url : '') + '"  alt="" /></a></div></div>';
                break;
            case '7':
                template = '<div class="layout-item" style="margin-right: ' + parseInt(data.range, 10) / 2 + 'px" data-index="1"><a href="' + (data.img[0] ? data.img[0].link : '') + '"><img src="' + (data.img[0] ? data.img[0].url : '') + '"  alt="" /></a></div><div class="layout-box" style="display: flex; flex: 1; flex-direction: column;"> <div class="layout-item" data-index="2" style="height: 50%; display: flex; margin-bottom: ' + parseInt(data.range, 10) / 4 + 'px "><a href="' + (data.img[1] ? data.img[1].link : '') + '"><img src="' + (data.img[1] ? data.img[1].url : '') + '"  alt="" /></a></div> <div class="layout-box"  style="height: 50%; display: flex;"><div class="layout-item" data-index="3" style="margin-right: ' + parseInt(data.range, 10) / 4 + 'px"><a href="' + (data.img[2] ? data.img[2].link : '') + '"><img src="' + (data.img[2] ? data.img[2].url : '') + '"  alt="" /></a></div><div class="layout-item" data-index="4"><a href="' + (data.img[3] ? data.img[3].link : '') + '"><img src="' + (data.img[3] ? data.img[3].url : '') + '"  alt="" /></a></div></div></div>';
                break;
        }

        return template
    }

    /**
     * [renderGoodsItem 渲染商品列表]
     * @param  {[any]} v [商品项]
     * @return {[jsx]}   [结构]
     */
    private renderGoodsItem(v: any) {
        return (
            <div className="card" key={v.goods_id}>
               <a onClick={() => pushPath('/offer', `?id=${v.goods_id}`) }>
                   <img src={ v.img_src } alt="" style={{height: (this.state.windowWidth - 4) * .94 * .485 + 'px'}} />
                    <p className="text1">{ v.goods_name }</p>
                    {
                        v.price_type === '3' ?
                        <p className="text2">面议</p> :
                        <p className="text2">{v.symbol}{v.price}</p>
                    }
                </a>
            </div>
        )
    }

    // 获取样式
    private async _getStyle() {
        const r = request({
            url: config.PHPAPI + 'api/wshop/shop/get-models',
            method: 'post',
            data: {
                shopId: this.state.shopId,
                shopDomain: this.state.shopDomain,
                modelsId: this.state.modelsId,
            }
        })

        r.then(res => {
            if (res.error_code === 0) {
                this.setState({
                    styleConfig: res.data.wap_configuration,
                });
            }
        })
    }

    private getQueryString(name: string) {
        const reg = new RegExp("(^|/?|&)" + name + "=([^&]*)(&|$)", "i");
        const r = decodeURIComponent(location.href).substr(1).match(reg);
        if (r != null) {
            return r[2]
        };
        return null;
    }

    // 获取广告位数据
    private async _getBanner() {
        const path: any = (window as any).shopId;

        const r = request({
            data: {
                shopDomain: path,
            },
            method: 'post',
            url: config.PHPAPI + 'api/wshop/shop/special',
        })

        r.then(res => {
            if (res.error_code === 0) {
                this.setState({
                    bannerList: res.data && res.data[0] && res.data[0].banner_sys_id === '4' ? res.data.slice(1) : res.data
                }, () => {
                    const swiperArr: any[] = [];
                    this.state.bannerList.forEach((v: any, k: number) => {
                        if (v.banner_info.length > 1) {
                            swiperArr[k] = new(window as any).Swiper(`.swiper${k}`, {
                                autoplay: true,
                                init: true,
                                loop: true,
                                pagination: {
                                    el: `.swiper-pagination${k}`,
                                }
                            });
                        }
                    });
                })
            }
        })
    }

    // 获取企业id
    private async _getId() {
        const path: any = (window as any).shopId;

        const r = request({
            data: {
                shopDomain: path,
            },
            method: 'post',
            url: config.PHPAPI + 'api/wshop/shop/shop-info',
        })

        r.then(res => {
            if (res.error_code === 0) {
                document.title = res.data[0].shop_name;
                this.setState({
                    id: res.data[0].company_id || '',
                    shopId: res.data[0].shop_id || '',
                    modelsId: this.getQueryString('modelsId') || res.data[0].models_id,
                    shopDomain: res.data[0].shop_domain || '',
                    shopInfo: res.data[0]
                }, () => {
                    this._getStyle();
                    this._getGoods();
                    // 如果是展会活动浏览，开始倒计时
                    if (this.state.fromExhibitionActivity) {
                        this.getExhibitionActivityStatus();
                    }
                });
            }
        })
    }

    // 获取商品数据
    private async _getGoods() {
        const path: any = (window as any).shopId;

        const r = await request({
            data: {
                typeId: 4,
                portType: 2,
                shopDomain: path,
            },
            method: 'post',
            url: `${config.PHPAPI}api/wshop/goods/tag-goods`,
        })

        if (r.error_code === 0) {
            this.setState({
                goodList: r.data
            });
        }
    }

    // 跳转详情
    private async _navigateToNewsDetail(url: string) {
        window.location.href = url;
    }
    private _renderAd(bk: number, bv: any) {
        if (Number(bv.type) === 3 || Number(bv.type) === 4) {
            return bv ? bv.banner_info.map(function(v: any, k: number) {
                return (
                    <div dangerouslySetInnerHTML={{__html: Number(bv.type) === 3 ? v.rich_content : v.html_content}} key={`specialHtmlItem${k}`}/>
                )
            }) : null
        } else if (Number(bv.type) === 5) {
            return <div className="warrper" style={{display: 'block'}}>
                {
                    bv.banner_info[0] && bv.banner_info[0].mofang ? bv.banner_info[0].mofang.map((cv: any, ck: number) => {
                        return <div className="model-box" style={{height: `${cv.imgHeight}px`}} key={`magic-Cube-${bk}${ck}`} dangerouslySetInnerHTML={{__html: this._renderModel(cv) }} />
                    }) : null
                }
                
            </div>
        }
    }

    // 获取关注数量
    private async getCollectionNum() {
        const r = await request({
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            method: 'get',
            url: `${config.PHPAPI}api/shop/activities/coll-count2`,
        });
        if (r.error_code === 0) {
            this.setState({
                collectionNum: Number(r.data.count)
            });
        }
    }

    /**
     * [setCollection 设置关注提示显示隐藏]
     * @param {[type]} visible: boolean [显示隐藏]
     */
    private setCollection(visible: boolean) {
        this.setState({
            collectVisible: visible
        });
    }

    /**
     * [codeInputAction 填写关注码]
     * @param  {[type]} index: number        [索引]
     * @return null
     */
    private codeInputAction(index: number) {
        const value = (event as any).target.value.replace(/\s+/g, "");
        const temp = this.state.collectCode;
        if (isNaN(value) || value === '') {
            temp[index] = '';
            (event as any).target.value = '';
        } else {
            temp[index] = value;
        }
        this.setState({
            collectCode: temp
        });
    }

    /**
     * [codeKeyUpAction 控制光标位置]
     * @param  {[type]} index: number        [索引]
     * @return null
     */
    private codeKeyUpAction(index: number) {

        let nextIndex = 0;
        if ((event as any).keyCode === 8) {
            nextIndex = index === 1 ? 1 : --index;
        } else {
            if (isNaN((event as any).target.value) || (event as any).target.value === '') {
                return;
            }
            nextIndex = index === 4 ? 4 : ++index;
        }

        (this.ref['elCode' + nextIndex] as any).focus();
    }

    // 提交注册码
    private async codeSubmit() {
        let message = '';
        if (this.state.collectCode.length === 0) {
            message = '请填写完整的确认码';
        }
        for (let i = 0; i < 4; i++) {
            if (typeof this.state.collectCode[i] === 'undefined' || this.state.collectCode[i] === '') {
                message = '请填写完整的确认码';
            } else if (isNaN(Number(this.state.collectCode[i]))) {
                message = '确认码只能为数值';
            }
        }
        if (message) {
            return this.showToastAction(message);
        }

        const SHOP_ID = (window as any).shopId;
        const r = await request({
            data: {
                collType: 1,
                shopDomain: SHOP_ID,
                code: this.state.collectCode.join('')
            },
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            method: 'post',
            url: `${config.PHPAPI}api/wshop/shop/collection`,
        });
        if (r.error_code === 0) {
            this.setState({
                isCollection: 1,
                collectCodeVisible: false
            });
            this.getCollectionNum();
            this.showToastAction('关注成功');
        } else {
            this.showToastAction(r.msg);
        }
    }

    // 隐藏提示框
    private hideToastAction() {
        if (this.toastTimer) {
            clearTimeout(this.toastTimer);
        }
        this.toastTimer = setTimeout(() => {
            this.setState({ toastText: '', toastVisible: false });
        }, 2000);
    }
    /**
     * [显示提示框]
     * @param  text [提示文本]
     */
    private showToastAction(text: string) {
        this.setState({ toastText: text, toastVisible: true });
        this.hideToastAction();
    }

    /**
     * [setcollectCodeVisible 控制关注码弹窗显示隐藏]
     * @param  {[boolean]} visible
     * @return null
     */
    private setCollectCodeVisible(visible: boolean) {
        this.setState({
            collectCodeVisible: visible
        });
    }

    // 获取页面活动关注
    private async getActivityCollection() {
        const r = await request({
            url: `${config.PHPAPI}api/shop/activities/is-collect`,
            data: {
                shopDomain: (window as any).shopId
            },
            method: 'post',
        });
        if (r.error_code === 0) {
            this.setState({
                isCollection: Number(r.data),
                collectCodeVisible: Number(r.data) === 0
            });
        }
    }

    // 跳转到活动
    private goToActivity() {
        (window as any).location.href = `${config.ACTIVITYAPI}activity/${config.ENV === 'production' ? 'pro' : 'dev'}/shop/scan/`;
    }

    // 头部活动收藏回调
    private collectCallBack() {
        this.setState({ isCollection: status });
        this.getCollectionNum();
    }

    // 展会活动浏览倒计时
    private exhibitionCountDown() {
        setTimeout(() => {
            const time = this.state.exhibitionTime - 1;
            this.setState({
                exhibitionTime: time
            }, () => {
                if (time > 0) {
                    this.exhibitionCountDown();
                } else {
                    this.completeTask();
                }
            });
        }, 1000);
    }

    // 完成任务
    private async completeTask() {
        await request({
            url: `${config.ZHAPI}api/member/exhibition/user-collect-activity`,
            method: 'post',
            data: {
                code: '',
                activityId: this.state.activityId,
                exhibitionId: this.state.exhibitionId,
                id: this.state.exhibitionMerchantId,
                companyId: this.state.activityId > 4 ? this.state.id : '',
                CMALL_TOKEN: utils.getCookie('CMALL_TOKEN')
            }
        });
    }

    // 兑奖
    private cashPrice() {
        if (this.state.exhibitionTime > 0) {
            return;
        }

        (window as any).location.href = `${config.ZHAPI}#/offline/?activityId=${this.state.activityId}&exhibitionId=${this.state.exhibitionId}&exhibitionMerchantId=${this.state.exhibitionMerchantId}&activityType=${this.state.activityType}`;
    }

    // 获取展会活动参与状态
    private async getExhibitionActivityStatus() {
        const r = await request({
            url: `${config.ZHAPI}api/member/activity/is-activity`,
            method: 'post',
            data: {
                activityId: this.state.activityId,
                exhibitionId: this.state.exhibitionId,
                merchantId: this.state.exhibitionMerchantId,
                companyId: this.state.activityId > 4 ? this.state.id : '',
                CMALL_TOKEN: utils.getCookie('CMALL_TOKEN')
            }
        });

        if (r.error_code === 0 && r.data === 1) {
            this.setState({
                exhibitionTime: 0
            });
        } else {
            this.exhibitionCountDown();
        }
    }

    // 添加客服
    private addService() {
        const code = document.createElement("script");
        code.src = "https://tb.53kf.com/code/code/1e0c405e33bd4cae61836123b5cc089e1/1";
        const s: any = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(code, s);
    }
}



ReactDOM.render(
    <Store />,
    document.getElementById('root') as HTMLElement
);


// WEBPACK FOOTER //
// ./src/containers/shop/index.tsx